/**
 * Form v2 — supForm runtime için rule evaluator.
 * FormModulePromt §3.3, §9.4, §9.5.
 * customer-panel/src/views/Pages/Forms/registry/conditionEvaluator.js ile aynı mantık.
 */

function isEmpty(v) {
    return v === null || v === undefined || v === "" || (Array.isArray(v) && v.length === 0);
}

function includesValue(arr, v) {
    if (!Array.isArray(arr)) return false;
    return arr.some(function (item) { return String(item) === String(v); });
}

// DropDownList değerini { selected, fieldLabel, altLabel } objesi olarak saklar;
// koşul karşılaştırması için içindeki "selected" değerine indirger.
function normalizeSourceValue(value) {
    if (value && typeof value === "object" && !Array.isArray(value) &&
        Object.prototype.hasOwnProperty.call(value, "selected")) {
        return value.selected;
    }
    return value;
}

export function compareOperator(operator, sourceValue, expected) {
    switch (operator) {
        case "equals": return String(sourceValue) === String(expected);
        case "notEquals": return String(sourceValue) !== String(expected);
        case "contains": return String(sourceValue || "").toLowerCase().indexOf(String(expected || "").toLowerCase()) !== -1;
        case "notContains": return String(sourceValue || "").toLowerCase().indexOf(String(expected || "").toLowerCase()) === -1;
        case "greaterThan": return Number(sourceValue) > Number(expected);
        case "lessThan": return Number(sourceValue) < Number(expected);
        case "isEmpty": return isEmpty(sourceValue);
        case "isNotEmpty": return !isEmpty(sourceValue);
        case "includes": return includesValue(sourceValue, expected);
        case "notIncludes": return !includesValue(sourceValue, expected);
        default: return false;
    }
}

function evaluateRule(rule, formValues) {
    if (!rule || !rule.sourceFieldId) return false;
    var sourceValue = normalizeSourceValue(formValues[String(rule.sourceFieldId)]);
    return compareOperator(rule.operator, sourceValue, rule.value);
}

function evaluateConditionGroup(group, formValues) {
    if (!group || !Array.isArray(group.rules) || group.rules.length === 0) return true;
    var results = group.rules.map(function (r) { return evaluateRule(r, formValues); });
    var passed = group.logic === "any" ? results.some(Boolean) : results.every(Boolean);
    if (group.when === "hide") return !passed;
    return passed;
}

export function evaluateFieldConditions(field, formValues) {
    if (!field || !Array.isArray(field.conditions) || field.conditions.length === 0) return true;
    return field.conditions.every(function (g) { return evaluateConditionGroup(g, formValues); });
}

export function evaluateBranchSection(field, formValues) {
    if (!field || field.type !== "branchSection" || !field.branchSection) return true;
    var bs = field.branchSection;
    if (!bs.sourceFieldId) return true;
    var sourceValue = normalizeSourceValue(formValues[String(bs.sourceFieldId)]);
    return compareOperator(bs.operator || "equals", sourceValue, bs.expectedValue);
}

export function evaluateConditions(formValues, fields) {
    var hiddenFieldIds = new Set();
    if (!Array.isArray(fields)) return { hiddenFieldIds: hiddenFieldIds };
    var values = formValues || {};

    fields.forEach(function (field) {
        if (!evaluateFieldConditions(field, values)) {
            hiddenFieldIds.add(String(field._id));
        }
    });

    fields.forEach(function (field) {
        if (field.type !== "branchSection") return;
        var visible = evaluateBranchSection(field, values);
        if (!visible) {
            hiddenFieldIds.add(String(field._id));
            if (field.branchSection && Array.isArray(field.branchSection.children)) {
                field.branchSection.children.forEach(function (cid) {
                    hiddenFieldIds.add(String(cid));
                });
            }
        }
    });

    fields.forEach(function (field) {
        if (field.parentBranchId && hiddenFieldIds.has(String(field.parentBranchId))) {
            hiddenFieldIds.add(String(field._id));
        }
    });

    return { hiddenFieldIds: hiddenFieldIds };
}

export default {
    evaluateConditions: evaluateConditions,
    evaluateFieldConditions: evaluateFieldConditions,
    evaluateBranchSection: evaluateBranchSection,
    compareOperator: compareOperator,
};
